var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 83.89 167.84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{mask:url(#mask);}.cls-2,.cls-25,.cls-27,.cls-4,.cls-6,.cls-8{mix-blend-mode:multiply;}.cls-2{fill:url(#linear-gradient);}.cls-3{mask:url(#mask-2);}.cls-4{fill:url(#linear-gradient-2);}.cls-5{mask:url(#mask-3);}.cls-6{fill:url(#linear-gradient-3);}.cls-7{mask:url(#mask-4);}.cls-8{fill:url(#linear-gradient-4);}.cls-9{isolation:isolate;}.cls-10{fill:url(#linear-gradient-5);}.cls-11{fill:url(#linear-gradient-6);}.cls-12{fill:#fff;}.cls-13{fill:url(#linear-gradient-7);}.cls-14{fill:url(#linear-gradient-8);}.cls-15,.cls-16,.cls-17,.cls-22,.cls-23,.cls-28{fill:#767676;}.cls-15,.cls-16,.cls-17,.cls-21,.cls-23,.cls-28,.cls-33{mix-blend-mode:color-burn;}.cls-15,.cls-21,.cls-25,.cls-27{opacity:0.3;}.cls-16{opacity:0.7;}.cls-17{opacity:0.4;}.cls-18{fill:url(#linear-gradient-9);}.cls-19{fill:url(#radial-gradient);}.cls-20{fill:#ff9d09;}.cls-23,.cls-33{opacity:0.2;}.cls-24{mask:url(#mask-5);}.cls-25{fill:url(#linear-gradient-10);}.cls-26{mask:url(#mask-6);}.cls-27{fill:url(#linear-gradient-11);}.cls-28{opacity:0.6;}.cls-29{fill:#e78b00;}.cls-30{fill:url(#linear-gradient-12);}.cls-31{fill:url(#linear-gradient-13);}.cls-32{fill:url(#linear-gradient-14);}.cls-33{fill:#a6a6a6;}.cls-34{mask:url(#mask-7);}.cls-35,.cls-37{mix-blend-mode:soft-light;opacity:0.8;}.cls-35{fill:url(#linear-gradient-15);}.cls-36{mask:url(#mask-8);}.cls-37{fill:url(#linear-gradient-16);}.cls-38{filter:url(#luminosity-noclip-8);}.cls-39{filter:url(#luminosity-noclip-7);}.cls-40{filter:url(#luminosity-noclip-6);}.cls-41{filter:url(#luminosity-noclip-5);}.cls-42{filter:url(#luminosity-noclip-4);}.cls-43{filter:url(#luminosity-noclip-3);}.cls-44{filter:url(#luminosity-noclip-2);}.cls-45{filter:url(#luminosity-noclip);}"), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip",
    x: 2913.56,
    y: -8417,
    width: 75.76,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 2913.56,
    y: -8417,
    width: 75.76,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 2922.1,
    y1: 220.76,
    x2: 2980.46,
    y2: 173.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#090909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#161616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#3f3f3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#5b5b5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#7d7d7d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#a5a5a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#d0d0d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#a9a9a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#7c7c7c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#565656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#363636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-2",
    x: 2913.56,
    y: -8417,
    width: 75.77,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    x: 2913.56,
    y: -8417,
    width: 75.77,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-44"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 2955.11,
    y1: 159.23,
    x2: 2947.76,
    y2: 234.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#a9a9a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#7c7c7c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#565656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#363636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-3",
    x: 2911.59,
    y: -8417,
    width: 68.82,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    x: 2911.59,
    y: -8417,
    width: 68.82,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 2975.3,
    y1: 228.16,
    x2: 2919.13,
    y2: 177.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-4",
    x: 2919.26,
    y: -8417,
    width: 66.55,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    x: 2919.26,
    y: -8417,
    width: 66.55,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 2974.72,
    y1: 213.8,
    x2: 2935.34,
    y2: 175.61,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -1840.41,
    y1: 103.48,
    x2: -1941.63,
    y2: -63.75,
    gradientTransform: "matrix(-1, 0, 0, 1, -1799.61, -69.69)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a51500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dd1d00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 52.2,
    y1: 77.76,
    x2: -23.5,
    y2: -58.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c8c8c8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -1838.72,
    y1: 91.35,
    x2: -1941.03,
    y2: -77.69,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 2908.15,
    y1: 192.06,
    x2: 2988.28,
    y2: 192.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9d09"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 2910.84,
    y1: 192.8,
    x2: 2992.04,
    y2: 192.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9d09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffda45"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 2951.44,
    cy: 196.94,
    r: 37.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdf10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc441"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-5",
    x: 2913.56,
    y: 159.05,
    width: 75.76,
    height: 75.76,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-5",
    x: 5.41,
    y: 89.36,
    width: 75.76,
    height: 75.76,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-41"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2908.15 -69.69)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2951.44,234.82a37.89,37.89,0,1,1,37.88-37.88A37.93,37.93,0,0,1,2951.44,234.82Z"
  }))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 2922.1,
    y1: 220.76,
    x2: 2980.46,
    y2: 173.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#f2dcdc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#e0a9a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#d07c7c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#c25656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#b73636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#ae1e1e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#a80d0d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#a40303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a30000"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-6",
    x: 2913.56,
    y: 159.06,
    width: 75.77,
    height: 75.76,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    x: 5.41,
    y: 89.36,
    width: 75.77,
    height: 75.76,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-40"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2908.15 -69.69)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2989.32,196.94a37.88,37.88,0,1,1-20.86-33.84A37.92,37.92,0,0,1,2989.32,196.94Z"
  }))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 2955.11,
    y1: 159.23,
    x2: 2947.76,
    y2: 234.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 96.48,
    y1: -32.14,
    x2: 32.87,
    y2: 66.1,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 41.07,
    y1: 42.14,
    x2: 77.88,
    y2: 42.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c8c8c8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 104.51,
    y1: -31.86,
    x2: 40.64,
    y2: 66.77,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-7",
    x: 2911.59,
    y: 170.91,
    width: 68.82,
    height: 60.28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-7",
    x: 3.44,
    y: 101.22,
    width: 68.82,
    height: 60.28,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-39"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2908.15 -69.69)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M2980.42,225.36a40,40,0,0,1-7.19,5.83l-.46-1.79-.25-1-2.11.26-5-4.52-49.13-41.32-1.09-4.17-3.61,1.18a8.59,8.59,0,0,0,.51-1.13c.3-.66.63-1.32,1-2a40,40,0,0,1,3-4.76l4.27-1.06.21,4.18,47.58,39.11,1.35,1.21v0h0l1.89,1.72,2.67,2.42h0l2.55,2.32.32.27.42.4h2l.16.42Z"
  }))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 2975.3,
    y1: 228.16,
    x2: 2919.13,
    y2: 177.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-8",
    x: 2919.26,
    y: 164.88,
    width: 66.55,
    height: 57.42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    x: 11.11,
    y: 95.19,
    width: 66.55,
    height: 57.42,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-38"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2908.15 -69.69)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M2985.81,218.57a39.3,39.3,0,0,1-2.69,3.74l-1.1-2.86-.05-.12h-2.13l-56.37-47.92-.41-3.51-3.8.15.43-.45c.47-.49.95-1,1.45-1.42s.73-.67,1.11-1l4.29-.33,0,3.4,55.07,46.46.7.64,2-.07h.26Z"
  }))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 2974.72,
    y1: 213.8,
    x2: 2935.34,
    y2: 175.61,
    xlinkHref: "#linear-gradient-15"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "24.44 0 44.19 84.28 47.05 84.28 29.57 0 24.44 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "18.52 0 40.42 84.28 44.19 84.28 24.44 0 18.52 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "13.01 0 37.82 84.28 40.42 84.28 18.52 0 13.01 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "13.01 0 37.82 84.28 40.42 84.28 18.52 0 13.01 0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M2985.41,181.82v0a42.6,42.6,0,0,0-5.84-10.21l0,0c-.17-.2-.32-.4-.49-.61l-.07-.08a40.58,40.58,0,0,0-20-13.34c-.3-.1-.59-.17-.89-.25q-.75-.21-1.53-.39h.8l.6,0h.79c0-.06.05-.36.11-.86a12.71,12.71,0,0,0-1.5-4.92v0s0,0,0,0a6.28,6.28,0,0,0-.52-.84s0,0,0-.07a7.17,7.17,0,0,0-6.18-2.9c-2.34,0-5.43.8-7,2.39-3.13,3.22-3.41,5.32-3.42,6.85v0a38.33,38.33,0,0,0-15.5,6.65c-.85.61-1.67,1.26-2.47,2-.38.31-.75.65-1.11,1s-1,.93-1.45,1.42l-.43.45h0c-.32.34-.63.69-.95,1-.8.92-1.55,1.88-2.27,2.87a40,40,0,0,0-3,4.76c-.33.64-.66,1.3-1,2-.18.37-.35.75-.51,1.13a43.44,43.44,0,0,0-3.44,17.1c0,18.63,12.73,33.52,29.68,38.27a42.9,42.9,0,0,0,11.68,1.61,39,39,0,0,0,22.41-6.79l.85-.61a36.16,36.16,0,0,0,6-5.55c.25-.28.49-.57.72-.86.63-.76,1.23-1.56,1.78-2.37.27-.39.53-.78.77-1.17s.51-.82.74-1.24a.25.25,0,0,0,.08-.12c.28-.47.55-1,.81-1.47s.45-.87.65-1.31a42.45,42.45,0,0,0,4-18.25A41.59,41.59,0,0,0,2985.41,181.82ZM2944,153.17c.17-.76.38-.39.7-.16s.47.26.79-.2a5.58,5.58,0,0,1,.59-.75,4.53,4.53,0,0,1,3.41-1.35,4.82,4.82,0,0,1,2.09.43,4.43,4.43,0,0,1,.7.41,2.62,2.62,0,0,1,.21.17c.13.09,2.89,2.42,2.81,4.07l-.4-.07a27.28,27.28,0,0,0-7.39-.15c-.82.08-1.58.21-2.34.33l-1,.14-.48.05A17,17,0,0,1,2944,153.17Z",
    transform: "translate(-2908.15 -69.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M2957.15,156.91s-2-1.15-1.86-1.12c.08-1.65-2.68-4-2.81-4.08a4.27,4.27,0,0,0-.9-.57,3.82,3.82,0,0,1,2,.12l.44.45C2955.07,153.38,2958.08,154.42,2957.15,156.91Z",
    transform: "translate(-2908.15 -69.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M2959.16,159.85l-4.15,0-10,.51-.92-4.3c1.13-.14,2.19-.35,3.38-.47a26.72,26.72,0,0,1,7.79.22s2.94,1.9,3,2C2958.85,159.17,2959.13,159.84,2959.16,159.85Z",
    transform: "translate(-2908.15 -69.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M2957.32,151.16h0a34.58,34.58,0,0,1-3.71-1.08l-6.51.89-.95.13-.67,1.71-.8.19-.69.17-1.82,4.63-.51-.32-1.44-.93c0-1.52.29-3.62,3.42-6.84a7.34,7.34,0,0,1,2.62-1.6,12.83,12.83,0,0,1,4.34-.79,7.57,7.57,0,0,1,5.26,1.84,5.66,5.66,0,0,1,.92,1.06,7.24,7.24,0,0,1,.53.91A0,0,0,0,1,2957.32,151.16Z",
    transform: "translate(-2908.15 -69.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M2960.15,157.28a8.37,8.37,0,0,0-1.75-5.14,16.89,16.89,0,0,0-1.62-1.92,7.69,7.69,0,0,0-5.86-2.16,8.44,8.44,0,0,0-3.6.76h0a7.9,7.9,0,0,0-2.23,1.62c-3.27,3.35-3.42,5.93-3.42,7v.06a40.5,40.5,0,0,0-18.6,10.38,38.93,38.93,0,0,0-2.76,3,39.91,39.91,0,0,0-5.11,7.74,40.58,40.58,0,0,0,65.22,46.71,35.38,35.38,0,0,0,2.71-3.05,38.11,38.11,0,0,0,2.68-3.75,40.6,40.6,0,0,0-25.65-61.28Zm-8.71-.94a41.93,41.93,0,0,0-6.38.5,7.72,7.72,0,0,1,.1-1c.19-.93.66-1.38,1.68-2.39l.68-.69a4.5,4.5,0,0,1,3.4-1.35,8.27,8.27,0,0,1,1.35.09,3.45,3.45,0,0,1,2.08,1,15.82,15.82,0,0,1,1.13,1.27,5.39,5.39,0,0,1,1.26,2.86A42.12,42.12,0,0,0,2951.44,156.34Z",
    transform: "translate(-2908.15 -69.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M2958.4,152.14l-2.92,1.69a15.82,15.82,0,0,0-1.13-1.27,3.45,3.45,0,0,0-2.08-1,8.27,8.27,0,0,0-1.35-.09,4.5,4.5,0,0,0-3.4,1.35l-.68.69.26-2.53.21-2.14h0a9.11,9.11,0,0,0-1.06-.71,12.83,12.83,0,0,1,4.34-.79,7.57,7.57,0,0,1,5.26,1.84c.29.35.59.71.92,1.06A16.89,16.89,0,0,1,2958.4,152.14Z",
    transform: "translate(-2908.15 -69.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M2951.44,234.82a37.89,37.89,0,1,1,37.88-37.88A37.93,37.93,0,0,1,2951.44,234.82Z",
    transform: "translate(-2908.15 -69.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M2943,221.21v-5.93h2.77V179.06h-3.31v-6.43h17.07v42.65h2.77v5.93Z",
    transform: "translate(-2908.15 -69.69)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M2959.47,215.27V172.63h-17v2.25h15.08v42.66h2.77v3.67h2v-5.94Z",
    transform: "translate(-2908.15 -69.69)"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "49.35 105.19 51.32 103.04 51.32 145.38 49.35 147.85 49.35 105.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "54.09 145.58 54.09 151.51 52.12 151.51 52.12 148.13 54.09 145.58"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M2951.44,234.82a37.89,37.89,0,1,1,37.88-37.88A37.93,37.93,0,0,1,2951.44,234.82Z",
    transform: "translate(-2908.15 -69.69)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-26"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M2989.32,196.94a37.88,37.88,0,1,1-20.86-33.84A37.92,37.92,0,0,1,2989.32,196.94Z",
    transform: "translate(-2908.15 -69.69)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M2989.32,196.94A37.93,37.93,0,0,1,2953,234.79c19.36-1.67,33.77-18,33.77-37.74,0-20.89-16.17-37.88-37.06-37.88-.58,0-1.14,0-1.71,0,1.12-.1,2.26-.16,3.41-.16A37.92,37.92,0,0,1,2989.32,196.94Z",
    transform: "translate(-2908.15 -69.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M2982.27,213.36s-1.08,2.67-2.54,3.4a3.78,3.78,0,0,1-2,.42h0a1.48,1.48,0,0,1-1.32-.91c-.37-1,.52-2.4,2-3.12a2.78,2.78,0,0,1,1.1-.27A7.42,7.42,0,0,1,2982.27,213.36Z",
    transform: "translate(-2908.15 -69.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M2974.44,215.6a1.11,1.11,0,0,1-1,.2,3.79,3.79,0,0,1-2.09-1.8c-.79-1.29-.7-3.6-.66-4.26,0-.12,0-.18,0-.18s2.47.64,3.4,2.16S2975.19,215,2974.44,215.6Z",
    transform: "translate(-2908.15 -69.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M2978.3,220.38s-1.46,2.42-3,2.84a3.7,3.7,0,0,1-1.34.13,1.85,1.85,0,0,1-1.85-1.29c-.22-1.05.88-2.25,2.43-2.67l.36-.06A6.63,6.63,0,0,1,2978.3,220.38Z",
    transform: "translate(-2908.15 -69.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M2969.59,221.31a.84.84,0,0,1-.52,0c-.76-.24-1.48-1.35-1.77-2.82a8.13,8.13,0,0,1,.68-4c.1-.24.17-.38.17-.38a7.66,7.66,0,0,1,2.42,3.5C2970.94,219.4,2970.5,221.06,2969.59,221.31Z",
    transform: "translate(-2908.15 -69.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M2985.22,204.22s-.64,2.85-2,3.87a3.36,3.36,0,0,1-2.39.82,1.29,1.29,0,0,1-.95-.61c-.51-.91.16-2.47,1.49-3.49a4.06,4.06,0,0,1,2.29-.67h0A7.71,7.71,0,0,1,2985.22,204.22Z",
    transform: "translate(-2908.15 -69.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M2978.32,208.23a1.37,1.37,0,0,1-1.44.55,4,4,0,0,1-1.89-.91c-1.29-1.09-1.84-4-1.84-4l.48,0h.11a5.11,5.11,0,0,1,3.22.81C2978.25,205.76,2978.87,207.35,2978.32,208.23Z",
    transform: "translate(-2908.15 -69.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M2982,189.19c-.58,1.63-1.7,2.65-2.54,2.39h0l-.13-.05c-.87-.43-1.05-2.16-.43-3.87a6.41,6.41,0,0,1,2.41-2.67l.5-.3S2982.58,187.48,2982,189.19Z",
    transform: "translate(-2908.15 -69.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M2978.08,192.3a1.69,1.69,0,0,1-1.9.9,4,4,0,0,1-1.42-.4c-1.47-.73-2.54-3.4-2.54-3.4a7.8,7.8,0,0,1,2.19-.48,3.37,3.37,0,0,1,1.67.26C2977.54,189.9,2978.44,191.3,2978.08,192.3Z",
    transform: "translate(-2908.15 -69.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M2983.81,198.79c-.83,1.17-1.9,1.79-2.67,1.61a1,1,0,0,1-.47-.25c-.72-.68-.48-2.41.52-3.85a5.49,5.49,0,0,1,2.93-1.76c.35-.1.58-.14.58-.14S2984.81,197.34,2983.81,198.79Z",
    transform: "translate(-2908.15 -69.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M2978.57,200.1a1.51,1.51,0,0,1-1.67.72,3.93,3.93,0,0,1-1.66-.63c-1.4-.9-2.24-3.69-2.24-3.69a8.78,8.78,0,0,1,1.5-.22h0a4,4,0,0,1,2.32.47C2978.26,197.65,2979,199.15,2978.57,200.1Z",
    transform: "translate(-2908.15 -69.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M2978.55,180.35c-.31,1.58-1.2,2.7-2,2.49l-.08,0c-.74-.29-1.09-1.69-.8-3.23a6,6,0,0,1,1.7-2.7c.24-.24.41-.38.41-.38A7.75,7.75,0,0,1,2978.55,180.35Z",
    transform: "translate(-2908.15 -69.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M2976,185c-.15.79-1.07,1.24-2.17,1.14a3.52,3.52,0,0,1-.62-.11c-1.36-.36-2.64-2.46-2.64-2.46a6.66,6.66,0,0,1,2.47-.94,2.25,2.25,0,0,1,.82,0C2975.22,183,2976.18,184,2976,185Z",
    transform: "translate(-2908.15 -69.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M2974.2,174.17c-.09,1.41-.72,2.51-1.42,2.46a.78.78,0,0,1-.25-.07c-.57-.27-1-1.34-.88-2.58a5.29,5.29,0,0,1,1.12-2.56c.19-.27.32-.42.32-.42A6.58,6.58,0,0,1,2974.2,174.17Z",
    transform: "translate(-2908.15 -69.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M2972.84,178.86c-.05.83-1.06,1.42-2.27,1.33h-.06a5.13,5.13,0,0,1-2.49-1.68,5.64,5.64,0,0,1,2.31-1.28,2.67,2.67,0,0,1,.4,0C2971.94,177.3,2972.89,178,2972.84,178.86Z",
    transform: "translate(-2908.15 -69.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M2970.46,174.59a1.16,1.16,0,0,1-1.3.5,3,3,0,0,1-1.24-.53c-1-.72-1.61-2.86-1.61-2.86a5.22,5.22,0,0,1,.91-.11,3.3,3.3,0,0,1,2,.41C2970.27,172.73,2970.82,173.89,2970.46,174.59Z",
    transform: "translate(-2908.15 -69.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M2981.69,213.36s-1.07,2.67-2.54,3.4a4.13,4.13,0,0,1-1.4.42h0a1.48,1.48,0,0,1-1.32-.91c-.37-1,.52-2.4,2-3.12a2.78,2.78,0,0,1,1.1-.27A7.8,7.8,0,0,1,2981.69,213.36Z",
    transform: "translate(-2908.15 -69.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M2973.86,215.6a1.07,1.07,0,0,1-.38.2,3.79,3.79,0,0,1-2.09-1.8c-.79-1.29-.7-3.6-.66-4.26a5.61,5.61,0,0,1,2.82,2C2974.48,213.23,2974.62,215,2973.86,215.6Z",
    transform: "translate(-2908.15 -69.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M2977.72,220.38s-1.45,2.42-3,2.84a4.17,4.17,0,0,1-.76.13,1.85,1.85,0,0,1-1.85-1.29c-.22-1.05.88-2.25,2.43-2.67l.36-.06A7.44,7.44,0,0,1,2977.72,220.38Z",
    transform: "translate(-2908.15 -69.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M2969.07,221.29c-.76-.24-1.48-1.35-1.77-2.82a8.13,8.13,0,0,1,.68-4,6.75,6.75,0,0,1,2,3.12C2970.35,219.36,2969.94,221,2969.07,221.29Z",
    transform: "translate(-2908.15 -69.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M2984.65,204.22s-.65,2.85-2,3.87a4,4,0,0,1-1.82.82,1.29,1.29,0,0,1-.95-.61c-.51-.91.16-2.47,1.49-3.49a4.06,4.06,0,0,1,2.29-.67h0A6.87,6.87,0,0,1,2984.65,204.22Z",
    transform: "translate(-2908.15 -69.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M2977.74,208.23a1.22,1.22,0,0,1-.86.55,4,4,0,0,1-1.89-.91c-1.29-1.09-1.84-4-1.84-4l.48,0h.11a4.61,4.61,0,0,1,2.64.81C2977.67,205.76,2978.28,207.35,2977.74,208.23Z",
    transform: "translate(-2908.15 -69.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M2981.38,189.19a3.7,3.7,0,0,1-2,2.39h0l-.13-.05c-.87-.43-1.05-2.16-.43-3.87a6.41,6.41,0,0,1,2.41-2.67A8.39,8.39,0,0,1,2981.38,189.19Z",
    transform: "translate(-2908.15 -69.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M2977.5,192.3a1.47,1.47,0,0,1-1.32.9,4,4,0,0,1-1.42-.4c-1.47-.73-2.54-3.4-2.54-3.4a7.8,7.8,0,0,1,2.19-.48,2.77,2.77,0,0,1,1.08.26C2977,189.9,2977.86,191.3,2977.5,192.3Z",
    transform: "translate(-2908.15 -69.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M2983.22,198.79a3.75,3.75,0,0,1-2.08,1.61,1,1,0,0,1-.47-.25c-.72-.68-.48-2.41.52-3.85a5.49,5.49,0,0,1,2.93-1.76C2984.13,195.15,2984.1,197.53,2983.22,198.79Z",
    transform: "translate(-2908.15 -69.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M2978,200.1a1.36,1.36,0,0,1-1.1.72,3.93,3.93,0,0,1-1.66-.63c-1.4-.9-2.24-3.69-2.24-3.69a8.78,8.78,0,0,1,1.5-.22h0a3.46,3.46,0,0,1,1.74.47C2977.68,197.65,2978.44,199.15,2978,200.1Z",
    transform: "translate(-2908.15 -69.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M2978,180.35a3.27,3.27,0,0,1-1.5,2.47c-.74-.29-1.09-1.69-.8-3.23a6,6,0,0,1,1.7-2.7A7,7,0,0,1,2978,180.35Z",
    transform: "translate(-2908.15 -69.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M2975.42,185a1.62,1.62,0,0,1-1.59,1.14,3.52,3.52,0,0,1-.62-.11c-1.36-.36-2.64-2.46-2.64-2.46a6.66,6.66,0,0,1,2.47-.94l.24,0C2974.65,183,2975.6,184,2975.42,185Z",
    transform: "translate(-2908.15 -69.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M2973.61,174.17a2.8,2.8,0,0,1-1.08,2.39c-.57-.27-1-1.34-.88-2.58a5.29,5.29,0,0,1,1.12-2.56A5.62,5.62,0,0,1,2973.61,174.17Z",
    transform: "translate(-2908.15 -69.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M2972.26,178.86c0,.71-.78,1.24-1.75,1.32a5.13,5.13,0,0,1-2.49-1.68,5.64,5.64,0,0,1,2.31-1.28C2971.45,177.37,2972.3,178.08,2972.26,178.86Z",
    transform: "translate(-2908.15 -69.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M2969.88,174.59a1,1,0,0,1-.72.5,3,3,0,0,1-1.24-.53c-1-.72-1.61-2.86-1.61-2.86a5.22,5.22,0,0,1,.91-.11,2.71,2.71,0,0,1,1.43.41C2969.69,172.73,2970.24,173.89,2969.88,174.59Z",
    transform: "translate(-2908.15 -69.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M2926.29,215.76c-.37,1.05-1.86,1.27-3.33.51l-.16-.1c-1.39-.87-2.38-3.47-2.38-3.47a6,6,0,0,1,3.61-.33l.25.11C2925.76,213.25,2926.65,214.71,2926.29,215.76Z",
    transform: "translate(-2908.15 -69.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M2931.31,213.38c-.92,1.59-2.29,2.34-3,1.68l-.05-.06c-.7-.71-.55-2.47.36-4a5.68,5.68,0,0,1,2.85-2.09l.54-.19S2932.24,211.79,2931.31,213.38Z",
    transform: "translate(-2908.15 -69.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M2930.61,221.84c-.21,1.1-1.65,1.65-3.21,1.21a2.76,2.76,0,0,1-.69-.34,9.11,9.11,0,0,1-2.32-2.64s2.23-1.48,3.78-1l.46.16C2929.94,219.73,2930.8,220.84,2930.61,221.84Z",
    transform: "translate(-2908.15 -69.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M2935.42,218.07c-.37,1.9-1.39,3.23-2.3,3a1,1,0,0,1-.42-.25c-.61-.6-.87-2.07-.57-3.65a7.37,7.37,0,0,1,2.1-3.37l.33-.32S2935.78,216.17,2935.42,218.07Z",
    transform: "translate(-2908.15 -69.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M2922.78,207.4c-.44.83-1.62.86-2.81.15,0,0,0,0,0,0a3.1,3.1,0,0,1-.51-.35c-1.33-1.07-2-4.06-2-4.06a6.74,6.74,0,0,1,3.07.2,2.74,2.74,0,0,1,.77.42C2922.63,204.81,2923.3,206.45,2922.78,207.4Z",
    transform: "translate(-2908.15 -69.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M2929.55,202.79s-.55,3-1.85,4.15c-1.14,1-2.43,1.26-3.09.67a1.08,1.08,0,0,1-.24-.28c-.54-.93.07-2.6,1.37-3.74a4.84,4.84,0,0,1,3.19-.84C2929.31,202.76,2929.55,202.79,2929.55,202.79Z",
    transform: "translate(-2908.15 -69.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M2923.41,189.81a1.14,1.14,0,0,1-1.23-.22,4.73,4.73,0,0,1-1.45-2.23c-.57-1.63.05-4.2.17-4.65l0-.07a7.35,7.35,0,0,1,2.92,3.11C2924.45,187.55,2924.26,189.36,2923.41,189.81Z",
    transform: "translate(-2908.15 -69.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M2930.49,187.58s-1.08,2.79-2.55,3.55a2.77,2.77,0,0,1-2.9.09,1.29,1.29,0,0,1-.42-.6c-.36-1.05.53-2.51,2-3.28a4.69,4.69,0,0,1,3.27,0A5.66,5.66,0,0,1,2930.49,187.58Z",
    transform: "translate(-2908.15 -69.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M2922,198.86a1.41,1.41,0,0,1-1.8-.08,4.57,4.57,0,0,1-1.34-1.36c-1-1.51-.9-4.6-.9-4.6a8.44,8.44,0,0,1,1.6.53,4.51,4.51,0,0,1,1.91,1.47C2922.5,196.33,2922.74,198.14,2922,198.86Z",
    transform: "translate(-2908.15 -69.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M2929.7,195s-.84,2.92-2.23,3.86c-1.14.77-2.35.88-3,.35a1.09,1.09,0,0,1-.35-.44c-.45-1,.31-2.57,1.71-3.51a4.82,4.82,0,0,1,3.26-.39A5.61,5.61,0,0,1,2929.7,195Z",
    transform: "translate(-2908.15 -69.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M2926.14,180.71a.94.94,0,0,1-.87-.28,4.17,4.17,0,0,1-1.12-2.34,7.93,7.93,0,0,1,.68-3.84c.05-.13.08-.19.08-.19a7,7,0,0,1,2.11,3.23C2927.34,179,2926.94,180.48,2926.14,180.71Z",
    transform: "translate(-2908.15 -69.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M2932.14,181.41s-1.29,2.21-2.65,2.59a2.7,2.7,0,0,1-2.27-.27,1.26,1.26,0,0,1-.52-.81c-.18-1,.77-2.06,2.14-2.45a3.73,3.73,0,0,1,2.26.37A6.86,6.86,0,0,1,2932.14,181.41Z",
    transform: "translate(-2908.15 -69.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M2929.92,174.18a.75.75,0,0,1-.63-.28,3.73,3.73,0,0,1-.79-2.29,6.7,6.7,0,0,1,.95-3.06c.1-.17.17-.27.17-.27a6.56,6.56,0,0,1,1.44,3.12C2931.14,172.88,2930.63,174.13,2929.92,174.18Z",
    transform: "translate(-2908.15 -69.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M2934.7,176.15s-1.35,1.67-2.57,1.77a2.54,2.54,0,0,1-1.68-.42,1.31,1.31,0,0,1-.59-1c0-.87.9-1.64,2.11-1.74a2.29,2.29,0,0,1,1,.18A6.39,6.39,0,0,1,2934.7,176.15Z",
    transform: "translate(-2908.15 -69.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M2936.41,169s-.58,2.25-1.62,3-1.89.76-2.36.27a1.08,1.08,0,0,1-.18-.24c-.37-.74.18-2,1.23-2.72a3.42,3.42,0,0,1,2.3-.41A4.49,4.49,0,0,1,2936.41,169Z",
    transform: "translate(-2908.15 -69.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M2925.71,215.48c-.33,1-1.59,1.22-2.91.69-1.39-.87-2.38-3.47-2.38-3.47a6,6,0,0,1,3.61-.33C2925.31,213.17,2926.05,214.5,2925.71,215.48Z",
    transform: "translate(-2908.15 -69.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M2930.75,213.09c-.75,1.28-1.78,2-2.54,1.91-.7-.71-.55-2.47.36-4a5.68,5.68,0,0,1,2.85-2.09A8.83,8.83,0,0,1,2930.75,213.09Z",
    transform: "translate(-2908.15 -69.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M2930,221.55c-.21,1.11-1.64,1.65-3.2,1.21l-.13,0a9.11,9.11,0,0,1-2.32-2.64s2.23-1.48,3.78-1l.46.16A2.46,2.46,0,0,1,2930,221.55Z",
    transform: "translate(-2908.15 -69.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M2934.85,217.79c-.34,1.79-1.28,3.08-2.15,3-.61-.6-.87-2.07-.57-3.65a7.37,7.37,0,0,1,2.1-3.37A8.55,8.55,0,0,1,2934.85,217.79Z",
    transform: "translate(-2908.15 -69.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M2922.22,207.12c-.37.69-1.28.83-2.25.43,0,0,0,0,0,0a3.1,3.1,0,0,1-.51-.35c-1.33-1.07-2-4.06-2-4.06a6.74,6.74,0,0,1,3.07.2l.2.14C2922.06,204.53,2922.73,206.16,2922.22,207.12Z",
    transform: "translate(-2908.15 -69.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M2928.93,202.75c-.16.75-.72,3-1.79,3.91a3.17,3.17,0,0,1-2.53,1,1.08,1.08,0,0,1-.24-.28c-.54-.93.07-2.6,1.37-3.74A4.84,4.84,0,0,1,2928.93,202.75Z",
    transform: "translate(-2908.15 -69.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M2922.84,189.53a.94.94,0,0,1-.66.06,4.73,4.73,0,0,1-1.45-2.23c-.57-1.63.05-4.2.17-4.65a6.44,6.44,0,0,1,2.37,2.76C2923.89,187.27,2923.7,189.08,2922.84,189.53Z",
    transform: "translate(-2908.15 -69.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M2929.89,187.38c-.19.46-1.2,2.79-2.52,3.48a3.32,3.32,0,0,1-2.33.36,1.29,1.29,0,0,1-.42-.6c-.36-1.05.53-2.51,2-3.28A4.69,4.69,0,0,1,2929.89,187.38Z",
    transform: "translate(-2908.15 -69.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M2921.45,198.57a1.15,1.15,0,0,1-1.23.21,4.57,4.57,0,0,1-1.34-1.36c-1-1.51-.9-4.6-.9-4.6a8.44,8.44,0,0,1,1.6.53,3.91,3.91,0,0,1,1.34,1.18C2921.94,196.05,2922.17,197.85,2921.45,198.57Z",
    transform: "translate(-2908.15 -69.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M2929.09,194.9c-.2.61-1,2.89-2.2,3.71a3.21,3.21,0,0,1-2.42.63,1.09,1.09,0,0,1-.35-.44c-.45-1,.31-2.57,1.71-3.51A4.82,4.82,0,0,1,2929.09,194.9Z",
    transform: "translate(-2908.15 -69.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M2925.58,180.42a.65.65,0,0,1-.31,0,4.17,4.17,0,0,1-1.12-2.34,7.93,7.93,0,0,1,.68-3.84,6.1,6.1,0,0,1,1.63,2.76C2926.77,178.67,2926.37,180.2,2925.58,180.42Z",
    transform: "translate(-2908.15 -69.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M2931.58,181.13s-1.29,2.21-2.66,2.58a3.17,3.17,0,0,1-1.7,0,1.26,1.26,0,0,1-.52-.81c-.18-1,.77-2.06,2.14-2.45a3.73,3.73,0,0,1,2.26.37Z",
    transform: "translate(-2908.15 -69.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M2929.36,173.9h-.07a3.73,3.73,0,0,1-.79-2.29,6.7,6.7,0,0,1,.95-3.06,5.42,5.42,0,0,1,1,2.57C2930.57,172.6,2930.06,173.85,2929.36,173.9Z",
    transform: "translate(-2908.15 -69.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M2934.13,175.87s-1.35,1.67-2.56,1.76a2.55,2.55,0,0,1-1.12-.13,1.31,1.31,0,0,1-.59-1c0-.87.9-1.64,2.11-1.74a2.29,2.29,0,0,1,1,.18A6.52,6.52,0,0,1,2934.13,175.87Z",
    transform: "translate(-2908.15 -69.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M2935.78,168.92a5.91,5.91,0,0,1-1.56,2.82,2.49,2.49,0,0,1-1.79.55,1.08,1.08,0,0,1-.18-.24c-.37-.74.18-2,1.23-2.72A3.42,3.42,0,0,1,2935.78,168.92Z",
    transform: "translate(-2908.15 -69.69)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "55.69 0 38.21 84.28 41.07 84.28 60.82 0 55.69 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "60.82 0 41.07 84.28 44.84 84.28 66.74 0 60.82 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "66.74 0 44.84 84.28 46.44 84.28 71.92 0 66.74 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "66.74 0 44.84 84.28 46.44 84.28 71.92 0 66.74 0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M2989.32,196.94a37.92,37.92,0,0,1-37.88,37.87c-1,0-2.06,0-3.07-.12A38,38,0,0,1,2916.66,212c56.21,13.13,53-38.47,52-47.62a4.92,4.92,0,0,0,.24-1,36.77,36.77,0,0,1,15.89,15.6A37.61,37.61,0,0,1,2989.32,196.94Z",
    transform: "translate(-2908.15 -69.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2989.32,196.94a37.92,37.92,0,0,1-37.88,37.87c-1,0-2.06,0-3.07-.12,25.7-8.9,33.48-36.27,35.83-51.73l1.74-1.66A35.38,35.38,0,0,1,2989.32,196.94Z",
    transform: "translate(-2908.15 -69.69)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-34"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M2980.42,225.36a40,40,0,0,1-7.19,5.83l-.46-1.79-.25-1-2.11.26-5-4.52-49.13-41.32-1.09-4.17-3.61,1.18a8.59,8.59,0,0,0,.51-1.13c.3-.66.63-1.32,1-2a40,40,0,0,1,3-4.76l4.27-1.06.21,4.18,47.58,39.11,1.35,1.21v0h0l1.89,1.72,2.67,2.42h0l2.55,2.32.32.27.42.4h2l.16.42Z",
    transform: "translate(-2908.15 -69.69)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-36"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M2985.81,218.57a39.3,39.3,0,0,1-2.69,3.74l-1.1-2.86-.05-.12h-2.13l-56.37-47.92-.41-3.51-3.8.15.43-.45c.47-.49.95-1,1.45-1.42s.73-.67,1.11-1l4.29-.33,0,3.4,55.07,46.46.7.64,2-.07h.26Z",
    transform: "translate(-2908.15 -69.69)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.4382a8ab622992d23ac8ccdfc2c29895.svg";
export { ForwardRef as ReactComponent };